import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Avatar,
    Badge,
    Button,
    Col,
    Form,
    Input,
    notification,
    Row,
    Select,
    Skeleton, Space, Spin,Tooltip,Upload,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { LogoutOutlined, LoadingOutlined, PlusOutlined, BookTwoTone, UserOutlined } from '@ant-design/icons';
import Parameters from 'shared/parameters';
import { AuthConsumer, logout } from 'shared/contexts/AuthContext';
import API_SERVICE from 'shared/services/api-service';
import { getImageUrl, UploadImage } from 'shared/services/Utility';
import TextArea from 'antd/es/input/TextArea';
import arrowLeft from '../../../src/img/arrow-left.png';
import vDOts from '../../../src/img/v-dots.png';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';
import moment from 'moment';
const { Option } = Select;
interface Props {
    location: any;
}
export default function ProfilePage(props: Props) {
    const { t } = useTranslation();
  const [viewStatus,setViewStatus] = useState(1 as number);
//   const [activeStats,getActiveStatus] = useState(1 as number);
  const user = JSON.parse(localStorage.getItem('auth-token') as string)?.user;
    return (
        <div className={'profile-wrapper container-fluid pl-0 pr-0'}>
            <AuthConsumer>
                {({ isAuth, updateUser, cartTime, cart, user }) => (
                    <>
                    <div className='d-md-flex'>
                        
                        <FrontendSidebar menuSelect={1} />
                        
                        <div className={'profile-tab-content-div pl-3 pr-3 mb-3'} style={{width: '100%'}}>
                        <div className='logout-button mb-3 text-right mt-2'>
                            <Button onClick={logout} icon={<LogoutOutlined />}>{t('genDict.logout')}</Button>
                        </div>
                        <div className='profileSection'>
                            {viewStatus === 1 && <ViewProfile updateUser={updateUser} setViewStatus={setViewStatus} />}
                            {viewStatus === 0 && <ProfileForm updateUser={updateUser} setViewStatus={setViewStatus} />}
                        </div>
                        </div>
                    </div>
                    </>
                )}
            </AuthConsumer>
        </div>
    );
}
function BadgeComponent() {
    const { t } = useTranslation();
    const [badges, setBadges] = useState([] as any[]);
    const params: any = { }
    useEffect(() => {
        API_SERVICE.getMyBadges(params).then(({ data: { data: { items } } }) => {
            setBadges(items);
            console.log('badgesssss',items)
        }).catch((e: any) => {
            notification.error({ message: t(API_SERVICE.handleErrors(e)) });
        });
    }, []);
    return <Space size={20}>
        {/* <Avatar.Group>
            {
                badges.map((badge: any) => {
                    {
                        }
                    return <Tooltip title={badge.title} placement='top'>
                        <Avatar style={{ backgroundColor: '#87d068' }}
                                src={Parameters.ImageBaseUrl + badge.image.slug + badge.image.ext}
                                icon={<UserOutlined />} />
                    </Tooltip>;
                })
            }
        </Avatar.Group> */}
    </Space>;
}
function ViewProfile({ updateUser,setViewStatus }: any){
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState({} as any);
    const [image, setImage] = useState({ image: null, imageId: null } as any);
    const settings = JSON.parse(localStorage.getItem('settings') as string);
    // const [viewStatus,setViewStatus] = useState(1 as number);
    const refresh = () => {
        API_SERVICE.me().then(({ data: { data: u } }) => {
            u['description'] = u['organizaion_description'];
            u['theme_config'] = settings && settings.theme_config ? JSON.parse(settings && settings.theme_config) : {};
            const { user: innerU } = u;
            const uFinal = innerU || u;
            setUser(uFinal);
            if (uFinal.avatar_image) {
                setImage({ image: getImageUrl(uFinal.avatar_image), imageId: uFinal.avatar });
            }
            if (uFinal.avatar) {
                setImage({ image: getImageUrl(uFinal.avatar), imageId: uFinal.avatar.id });
            }
            updateUser();
        }).catch((e: any) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        }).finally(() => {
            setLoading(false);
        });
    };
    useEffect(() => {
        refresh();
    }, []);

    if (loading || user === null) {
        return <Skeleton active={true} />;
    }

    return <div>
        <div className='row mb-3'>
            {console.log('userrr',user)
            }
            <div className='col-md-12 ml-3 p-0 d-flex align-items-center'>
                {/* <div className='mr-4'>
                <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                </div> */}
                <div><h3 className='mb-0'>{t('genDict.YourProfile')}</h3></div>
            </div>
        </div>
        <div className='bg-white p-3 br-5px'>
            <div className="row">
                <div className="col-sm-6 pb-3">
                    <div className="d-flex align-items-center">
                        <div className="mr-3">
                            <img src={ user?.avatar_image ? Parameters.ImageBaseUrl + user?.avatar_image?.slug + user?.avatar_image?.ext : Parameters.ImageBaseUrl + user?.avatar?.slug + user?.avatar?.ext} className="uploaded-img-cat" height="50" width="50"/>
                        </div>
                        <div className="">
                            <h5 className="mb-0 font-18px">
                                <span>{user.name}</span> {
                                        <Tooltip title={t('genDict.freeCoursesAllowedInPackages')}>
                                            <Badge showZero count={user.remainingFreeCoursesCount}>
                                                <BookTwoTone style={{ fontSize: '30px' }} />
                                            </Badge>
                                        </Tooltip>
                                }
                            </h5>
                        </div>
                    </div>
                    
                </div>
                <div className="col-sm-6 pb-3 text-sm-right my-auto">
                    <span className="text-secondary mr-4">{t('genDict.CreatedOn')} {moment(user.created_at).format('DD MMMM, YYYY')}</span>
                    <span className="dropdown">
                        <a role="button" className="dropdown-toggler" data-toggle="dropdown">
                            <img src={vDOts} style={{width: '25px'}} />
                        </a>
                        <div className="dropdown-menu">
                        <a className="dropdown-item" role="button"
                        onClick={() => {
                            setViewStatus(0);
                        }}
                        >{t('genDict.Edit')}</a>
                        </div>
                    </span>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 pb-3">
                    <div className="table-responsive mt-2">
                       {Parameters.Mode === 'CLIENT' && <table className="table course-details-table box-shadow">
                            
                            <tbody>
                            <tr>
                                <td className="w-280px text-secondary">{t('genDict.EmailAddress')}</td>
                                <td>{user.email}</td>
                            </tr>
                            <tr>
                                <td className="w-280px text-secondary">{t('genDict.PhoneNumber')}</td>
                                <td>{user.phone}</td>
                            </tr>
                            <tr>
                                <td className="w-280px text-secondary">{t('genDict.gender')}</td>
                                <td>{user.gender}</td>
                            </tr>
                            {user?.role?.slug === 'STUDENT' && <tr>
                                <td className="w-280px text-secondary">{t('genDict.YourProfile')}</td>
                                <td>
                                    {user.course_subscribes}
                                </td>
                            </tr>
                            }
                            {user?.role?.slug === 'STUDENT' && <tr>
                                <td className="w-280px text-secondary">{t('genDict.GraduatedIn')}</td>
                                <td>
                                {user.graduated_in_courses}
                                </td>
                            </tr>
                            }
                            {user?.role?.slug === 'INSTRUCTOR' && <tr>
                                <td className="w-280px text-secondary">{t('genDict.YourProfile')}</td>
                                <td>
                                    {user.instructor_courses}
                                </td>
                            </tr>
                            }
                            {user?.role?.slug === 'STUDENT' && <tr>
                                <td className="w-280px text-secondary">{t('genDict.Badge')}</td>
                                <td>
                                    {user.badges}
                                </td>
                            </tr>
                            }
                            </tbody>
                        </table>}
                        {Parameters.Mode === 'ADMIN' && <table className="table course-details-table box-shadow">
                            
                            <tbody>
                            <tr>
                                <td className="w-280px text-secondary">{t('genDict.name')}</td>
                                <td>{user.name}</td>
                            </tr>
                            <tr>
                                <td className="w-280px text-secondary">{t('genDict.EmailAddress')}</td>
                                <td>{user.email}</td>
                            </tr>
                            <tr>
                                <td className="w-280px text-secondary">{t('genDict.theme')}</td>
                                <td>{user.theme_config.color}</td>
                            </tr>
                            <tr>
                                <td className="w-280px text-secondary">{t('genDict.description')}</td>
                                <td>{user.description}</td>
                            </tr>
                            <tr>
                                <td className="w-280px text-secondary">{t('genDict.homeTitle')}</td>
                                <td>
                                    {user.theme_config.homeTitle}
                                </td>
                            </tr>
                            <tr>
                                <td className="w-280px text-secondary">{t('genDict.homeDescription')}</td>
                                <td>
                                    {user.theme_config.homeDescription}
                                </td>
                            </tr>
                            </tbody>
                        </table>}
                    </div>
                </div>
            </div>
        </div>
    </div>
}

function ProfileForm({ updateUser, setViewStatus }: any) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [formOrg] = Form.useForm();
    const [fields]: any[] = [];
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState({} as any);
    const [uploading, setUploading] = useState(false);
    const [image, setImage] = useState({ image: null, imageId: null } as any);
    const settings = JSON.parse(localStorage.getItem('settings') as string);
    const refresh = () => {
        API_SERVICE.me().then(({ data: { data: u } }) => {
            u['description'] = u['organizaion_description'];
            u['theme_config'] = settings && settings.theme_config ? JSON.parse(settings && settings.theme_config) : {};
            const { user: innerU } = u;
            const uFinal = innerU || u;
            setUser(uFinal);
            if (uFinal.avatar_image) {
                setImage({ image: getImageUrl(uFinal.avatar_image), imageId: uFinal.avatar });
            }
            if (uFinal.avatar) {
                setImage({ image: getImageUrl(uFinal.avatar), imageId: uFinal.avatar.id });
            }
            updateUser();
        }).catch((e: any) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        }).finally(() => {
            setLoading(false);
        });
    };
    const uploadImage = async (file: any) => {
        setUploading(true);
        setImage({ image: null, imageId: null });
        const { image, imageId, error } = await UploadImage(file);
        if (error) {
            notification.error({ message: error });
        }
        setImage({ image, imageId });
        setUploading(false);
    };

    useEffect(() => {
        refresh();
    }, []);
    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>{t('genDict.upload')}</div>
        </div>
    );
    const updateProfile = async (value: any) => {
        try {
            setLoading(true);
            const reqObj = { ...value };
            if (image.imageId) {
                reqObj['avatar'] = image.imageId;
            }
            await API_SERVICE.updateProfile(reqObj);
            notification.success({
                message: t('Updated successfully'),
            });
            refresh();
        } catch (e) {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        } finally {
            setLoading(false);
        }
    };
    const updateOrgProfile = async (value: any) => {
        try {
            setLoading(true);
            const reqObj = { ...value };
            await API_SERVICE.updateOrgProfile(reqObj);
            notification.success({
                message: t('Updated successfully'),
            });
            refresh();
            window.location.reload();
        } catch (e) {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        } finally {
            setLoading(false);
        }
    };
    if (loading || user === null) {
        return <Skeleton active={true} />;
    }

    return <div>
        {/* <Title level={2}>{user.name} {
            Parameters.Mode === 'CLIENT' && <><BadgeComponent /> &nbsp;&nbsp;
                <Tooltip title={t('genDict.freeCoursesAllowedInPackages')}>
                    <Badge showZero count={user.remainingFreeCoursesCount}>
                        <BookTwoTone style={{ fontSize: '30px' }} />
                    </Badge>
                </Tooltip></>
        }
        </Title> */}

        <div className="container-fluid">
                <div className='row mb-3'>
                    <div className='col-md-12 p-0 d-flex align-items-center'>
                        <div className='mr-4'>
                            <span className='bg-back cursor-pointer' 
                                onClick={() => setViewStatus(1)}
                            >
                                <img src={arrowLeft} className="page-back" />
                            </span>
                        </div>
                        <div><h3 className='mb-0'>{t('genDict.editProfile')}</h3></div>
                    </div>
                </div>
                {Parameters.Mode === 'CLIENT' && <div className='row'>
                    <div className='col-md-12'>
                        <div className='bg-white p-3 br-5px'>
                            <div className='pt-3 pb-3 pl-4 pr-6rem'>
                                <Row>
                                    <Col lg={10} md={10} sm={24} xs={24}>
                                        <h5>{t('genDict.uploadAvatar')}</h5>
                                        <p className="text-secondary">{t('genDict.paragraph')}</p>
                                    </Col>
                                    <Col lg={14} md={14} sm={24} xs={24}>
                                        <Upload
                                            name='avatar'
                                            listType='picture-card'
                                            className='avatar-uploader'
                                            showUploadList={false}
                                            beforeUpload={(file) => {
                                                if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                                                    notification.error({ message: `PNG/JPG/JPEG ${t('genDict.required')}` });
                                                }
                                                uploadImage(file);
                                                return false;
                                            }}
                                        >
                                            {uploading ? <Spin /> : (image.image ?
                                                <img src={image.image} alt='avatar' style={{ width: '100%' }} /> : uploadButton)}
                                        </Upload>
                                    </Col>
                                </Row>
                                <hr/>
                                <Form
                                    size='large'
                                    className={'profile-form'}
                                    form={form}
                                    fields={fields}
                                    onFinish={async (value) => {
                                        updateProfile(value);
                                    }
                                    }
                                    initialValues={user}
                                    layout='vertical'
                                    requiredMark={false}
                                >
                                    <Row>
                                        <Col lg={10} md={10} sm={24} xs={24} className="mt-4">
                                            <h5>{t('genDict.Information')}</h5>
                                            <p className="text-secondary">{t('genDict.paragraph')}</p>
                                        </Col>
                                        
                                        <Col lg={14} md={14} sm={24} xs={24} className="mt-4">
                                        
                                            <Form.Item
                                                label={t('profile.name.label')}
                                                name='name'
                                                rules={[
                                                    { required: true, message: t('profile.name.required') },
                                                ]}
                                            >
                                                <Input className='br-1' />
                                            </Form.Item>
                                            <Row>
                                                <Col lg={12} md={12} sm={24} xs={24} className="pr-sm-2">
                                                    <Form.Item
                                                        label={t('profile.email.label')}
                                                        name='email'
                                                        rules={[
                                                            {
                                                                required: true, type: 'email',
                                                                message: t('profile.email.required'),
                                                            },
                                                        ]}
                                                    >
                                                        <Input className='br-1' disabled type={'email'} />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} md={12} sm={24} xs={24} className="pl-sm-2">
                                                    <Form.Item
                                                        label={t('profile.phone.label')}
                                                        name='phone'
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: t('profile.phone.required'),
                                                            },
                                                        ]}
                                                    >
                                                        <Input className='br-1' />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} md={12} sm={24} xs={24}>
                                                    <Form.Item
                                                        label={t('profile.gender.label')}
                                                        name='gender'
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: t('profile.gender.required'),
                                                            },
                                                        ]}
                                                    >
                                                        <Select className='br-1'>
                                                            {
                                                                ['male', 'female'].map((a) => {
                                                                    return <Option value={a}>{t('genDict.' + a)}</Option>;
                                                                })
                                                            }
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col lg={12} md={12} sm={24} xs={24} className="pr-sm-2">
                                                    <Form.Item>
                                                        <Button
                                                            htmlType='submit'
                                                            loading={loading}
                                                            shape='round'
                                                            size={'large'}
                                                            className='submit btn btn-blue'
                                                        >
                                                            {t('profile.update')}
                                                        </Button>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Form>
                                <hr/>
                                <Row>
                                    <Col lg={10} md={10} sm={24} xs={24} className="mt-4">
                                        <h5>{t('genDict.security')}</h5>
                                        <p className="text-secondary">{t('genDict.paragraph')}</p>
                                    </Col>
                                    
                                    <Col lg={14} md={14} sm={24} xs={24} className="mt-4">
                                        <ChangePasswordForm user={user} />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        {/* <Title level={4}>{t('genDict.updateProfile')}</Title>
        <Upload
            name='avatar'
            listType='picture-card'
            className='avatar-uploader'
            showUploadList={false}
            beforeUpload={(file) => {
                if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                    notification.error({ message: `PNG/JPG/JPEG ${t('genDict.required')}` });
                }
                uploadImage(file);
                return false;
            }}
        >
            {uploading ? <Spin /> : (image.image ?
                <img src={image.image} alt='avatar' style={{ width: '100%' }} /> : uploadButton)}
        </Upload>
        <Form
            size='large'
            className={'profile-form'}
            form={form}
            fields={fields}
            onFinish={async (value) => {
                updateProfile(value);
            }
            }
            initialValues={user}
            layout='vertical'
            requiredMark={false}
        >
            <Form.Item
                label={t('profile.name.label')}
                name='name'
                rules={[
                    { required: true, message: t('profile.name.required') },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label={t('profile.email.label')}
                name='email'
                rules={[
                    {
                        required: true, type: 'email',
                        message: t('profile.email.required'),
                    },
                ]}
            >
                <Input disabled type={'email'} />
            </Form.Item>

            <Form.Item
                label={t('profile.phone.label')}
                name='phone'
                rules={[
                    {
                        required: true,
                        message: t('profile.phone.required'),
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <br />
            <Form.Item>
                <Button
                    type='primary'
                    htmlType='submit'
                    loading={loading}
                    shape='round'
                    size={'large'}
                    className='submit'
                >
                    {t('profile.update')}
                </Button>
            </Form.Item>
        </Form> */}

{Parameters.Mode === 'ADMIN' && <div className='row'>
                    <div className='col-md-12'>
                        <div className='bg-white p-3 br-5px'>
                            <div className='pt-3 pb-3 pl-4 pr-6rem'>
                            <Row>
                                <Col lg={10} md={10} sm={24} xs={24} className="mt-4">
                                    <h5>{t('genDict.Information')}</h5>
                                    <p className="text-secondary">{t('genDict.paragraph')}</p>
                                </Col>
                                
                                <Col lg={14} md={14} sm={24} xs={24} className="mt-4">
                                    <Form
                                        size='large'
                                        className={'profile-form'}
                                        form={formOrg}
                                        fields={fields}
                                        onFinish={async (value) => {
                                            updateOrgProfile(value);
                                        }
                                        }
                                        initialValues={user}
                                        layout='vertical'
                                        requiredMark={false}
                                    >
                                        <Form.Item
                                            label={t('organization.name.label')}
                                            name='name'
                                            rules={[
                                                {
                                                    required: true,
                                                    message: t('organization.name.required'),
                                                },
                                            ]}
                                        >
                                            <Input className='br-1' />
                                        </Form.Item>
                                        <Form.Item
                                            label={t('organization.theme.label')}
                                            name={['theme_config', 'color']}
                                            rules={[]}
                                        >
                                            <Select className='br-1'>
                                                <Select.Option value={'default'}>{t('genDict.Default')}</Select.Option>
                                                <Select.Option value={'theme-red'}>
                                                    <Space>{t('genDict.Red')} <div
                                                        style={{ width: '20px', height: '20px', background: 'red' }}/></Space>
                                                </Select.Option>
                                                <Select.Option value={'theme-orange'}>
                                                    <Space>{t('genDict.Orange')} <div
                                                        style={{ width: '20px', height: '20px', background: 'orange' }}/></Space>
                                                </Select.Option>
                                                <Select.Option value={'theme-green'}>
                                                    <Space>{t('genDict.Green')} <div
                                                        style={{ width: '20px', height: '20px', background: 'green' }}/></Space>
                                                </Select.Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            label={t('organization.description.label')}
                                            name='description'
                                            rules={[
                                                {
                                                    required: true,
                                                    message: t('organization.description.required'),
                                                },
                                            ]}
                                        >
                                            <Input className='br-1' />
                                        </Form.Item>
                                        <Form.Item
                                            label={t('organization.homeTitle.label')}
                                            name={['theme_config', 'homeTitle']}
                                            rules={[]}
                                        >
                                            <TextArea rows={3} />
                                        </Form.Item>
                                        <Form.Item
                                            label={t('organization.homeDescription.label')}
                                            name={['theme_config', 'homeDescription']}
                                            rules={[]}
                                        >
                                            <TextArea className='br-1' rows={3} />
                                        </Form.Item>
                                        <br />
                                        <Form.Item>
                                            <Button
                                                htmlType='submit'
                                                loading={loading}
                                                shape='round'
                                                size={'large'}
                                                className='submit btn btn-blue'
                                            >
                                                {t('profile.update')}
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </Col>
                            </Row>
                            <hr/>
                            <Row>
                                <Col lg={10} md={10} sm={24} xs={24} className="mt-4">
                                    <h5>{t('genDict.security')}</h5>
                                    <p className="text-secondary">{t('genDict.paragraph')}</p>
                                </Col>
                                
                                <Col lg={14} md={14} sm={24} xs={24} className="mt-4">
                                    <ChangePasswordForm user={user} />
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>}
        {/* {
            Parameters.Mode === 'ADMIN' && <>
                <Title level={4}> Organization Update</Title>
                <Form
                    size='large'
                    className={'profile-form'}
                    form={formOrg}
                    fields={fields}
                    onFinish={async (value) => {
                        updateOrgProfile(value);
                    }
                    }
                    initialValues={user}
                    layout='vertical'
                    requiredMark={false}
                >
                    <Form.Item
                        label={t('organization.name.label')}
                        name='name'
                        rules={[
                            {
                                required: true,
                                message: t('organization.name.required'),
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={t('organization.theme.label')}
                        name={['theme_config', 'color']}
                        rules={[]}
                    >
                        <Select>
                            <Select.Option value={'default'}>Default</Select.Option>
                            <Select.Option value={'theme-red'}>
                                <Space>Red <div
                                    style={{ width: '20px', height: '20px', background: 'red' }}/></Space>
                            </Select.Option>
                            <Select.Option value={'theme-orange'}>
                                <Space>Orange <div
                                    style={{ width: '20px', height: '20px', background: 'orange' }}/></Space>
                            </Select.Option>
                            <Select.Option value={'theme-green'}>
                                <Space>Green <div
                                    style={{ width: '20px', height: '20px', background: 'green' }}/></Space>
                            </Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={t('organization.description.label')}
                        name='description'
                        rules={[
                            {
                                required: true,
                                message: t('organization.description.required'),
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={t('organization.homeTitle.label')}
                        name={['theme_config', 'homeTitle']}
                        rules={[]}
                    >
                        <TextArea rows={3} />
                    </Form.Item>
                    <Form.Item
                        label={t('organization.homeDescription.label')}
                        name={['theme_config', 'homeDescription']}
                        rules={[]}
                    >
                        <TextArea rows={3} />
                    </Form.Item>
                    <br />
                    <Form.Item>
                        <Button
                            type='primary'
                            htmlType='submit'
                            loading={loading}
                            shape='round'
                            size={'large'}
                            className='submit'
                        >
                            {t('profile.update')}
                        </Button>
                    </Form.Item>
                </Form>
            </>
        } */}
    </div>;
}

function ChangePasswordForm({ user }: any) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [fields]: any[] = [];
    const [loading, setLoading] = useState(false);
    return <Form
        size='large'
        className={'profile-form'}
        form={form}
        fields={fields}
        onFinish={async (value) => {
            try {
                const req = { ...user, ...value };
                req['avatar'] = req['avatar']['id'];
                delete req['country_id'];
                setLoading(true);
                await API_SERVICE.updateProfile(req);
                notification.success({
                    message: t('Updated successfully'),
                });
            } catch (e) {
                notification.error({
                    message: API_SERVICE.handleErrors(e),
                });
            } finally {
                setLoading(false);
            }
        }
        }
        layout='vertical'
        requiredMark={false}
    >
        {/* <Title level={3}>{t('genDict.changePassword')}</Title> */}
        <div className='__password'>
            <Form.Item
                label={t('profile.password.label')}
                name='password'
                rules={[
                    { required: true, message: t('profile.password.required') },
                ]}
            >
                <Input.Password className='br-1'
                    onChange={() => {
                        form.validateFields(['password_confirmation']);
                    }}
                    type='password'
                />
            </Form.Item>
        </div>
        <div className='__password'>
            <Form.Item
                label={t('profile.password_confirmation.label')}
                name='password_confirmation'
                rules={[
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value) {
                                return Promise.reject(
                                    t('profile.password.required'),
                                );
                            }
                            if (value && getFieldValue('password') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(
                                t('profile.password.unmatched'),
                            );
                        },
                    }),
                ]}
            >
                <Input.Password className='br-1'
                    type='password'
                />
            </Form.Item>
        </div>
        <br />
        <Form.Item>
            <Button
                htmlType='submit'
                loading={loading}
                shape='round'
                size={'large'}
                className='submit btn btn-blue'
            >
                {t('profile.changePassword')}
            </Button>
        </Form.Item>
    </Form>;
}
